import { ACTION_TASK_CONSTANTS } from "@/modules/Dashboards/AdminDashboard/constants/ActionConstants";
import { TASK_STATES_ARRAY } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";

Vue.use(Vuetify);

@Component({
  name: "UpdateTask",
  components: { DynamicSelect }
})
export default class UpdateTask extends Vue {
  @Prop() state!: string;

  listStateConfig: DynamicSelectConfig = {
    listAll: [],
    default: [],
    messageLabel: ACTION_TASK_CONSTANTS.LABELS.STATE_LABEL,
    required: true
  };
  listStateModel = [{ id: "", name: "" }];

  mounted() {
    const [, ...taskStates] = [...TASK_STATES_ARRAY];
    this.listStateConfig.listAll = taskStates.map(item => {
      return { id: item.key, name: item.name };
    });
  }

  @Watch("listStateModel")
  updateState() {
    this.$emit(
      ACTION_TASK_CONSTANTS.EMMITS.UPDATE_STATE,
      this.listStateModel[0].id
    );
  }
}
